import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import "./Sidebar.css";
import BubbleNetwork from "./logo/BubbleNetwork";
import { FaCog, FaBoxOpen , FaBullhorn,FaCommentDots,FaUsers,FaHandshake,FaChartLine,FaAngleLeft } from "react-icons/fa";
//import file_icon from "../Images/file-icon.png"; // Assuming you have a file icon image
// import BubbleNetwork from "./logo/BubbleNetwork";

const PanelSidebar = ({ role, collapsed }) => {
  const location = useLocation();
  const { panel } = useParams();
  const [permissions, setPermissions] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  console.log(role, "role and permissions");

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/rolepermission/${role}/permissions`);
        console.log(res, "res--<>>");
        setPermissions(res.data); // [{ name: 'User Management', key: 'user_management' }]
      } catch (err) {
        console.error("Failed to fetch permissions", err);
      }
    };

    if (role) {
      fetchPermissions();
    }
  }, [role]);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.sidebar-container') && !event.target.closest('.hamburger-button')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileMenuOpen]);

  const isOnPanelRoot = location.pathname === `/settings/${panel}`;
  const backLink = isOnPanelRoot ? "/dashboard" : `/settings/${panel}`;
  const backLabel = isOnPanelRoot ? "Back to Dashboard" : "Back";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };



  return (
    <>
      {/* Hamburger button - only visible on mobile */}
      <button 
        className="hamburger-button"
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        {/* <span>
              <BubbleNetwork />
              <h2>MedhasAI</h2>
            </span> */}
        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
      </button>
              
      {/* Mobile overlay */}
      {mobileMenuOpen && <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)}></div>}

      <aside className={`sidebar-container ${collapsed ? "collapsed" : ""} ${mobileMenuOpen ? "mobile-open" : ""}`}>
        <div className="mobile-sidebar-logo" >
              <BubbleNetwork />
              <h2>Medhas AI</h2>
            </div>
        <ul>
          {permissions.map(({ key, name }) => {
            const isActive = location.pathname.endsWith(key);
            return (
              <li key={key} className="sidebar-item">
                <Link
                  to={`/settings/${panel}/${key}`}
                  className={isActive ? "active" : ""}
                >
                  <span className="icon">
                    {key === 'user_management' && <FaUsers />}
                    {key === 'account_settings' && <FaCog />}
                    {key === 'create_product' && <FaBoxOpen />}
                    {key === 'feedback_management' && <FaCommentDots />}
                    {key === 'customer_outreach' && <FaBullhorn />}
                    {key === 'tickets' && <FaHandshake />}
                    {key === 'partner_dashboard' && <FaChartLine />}
                    {!['user_management', 'account_settings', 'create_product', 'feedback_management'].includes(key)}
                  </span>
                  {!collapsed && <span className="label">{name}</span>}
                </Link>
              </li>
            );
          })}

          

          {/* Back button */}
          <li className="sidebar-item back-button">
            <Link to={backLink}>
              <span className="icon"><FaAngleLeft/></span>
              {!collapsed && <span className="label">{backLabel}</span>}
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default PanelSidebar;